import React from "react"

import {
	Box,
	Button,
	Divider, IconButton,
	List,
	ListItemButton,
	Pagination,
	Stack, Tooltip,
	Typography,
} from "@mui/material"
import {
	TabContext,
	TabPanel,
} from "@mui/lab"

import {
	t,
	Trans,
} from "@lingui/macro"
import Icon from "@mdi/react"
import {mdiInformationOutline, mdiPlusBox} from "@mdi/js"

import {
	PaginatedResponse,
	PaginationInfo,
	Template,
} from "models"
import {
	SbTab,
	SbTabList,
} from "components/commons"

import { TemplateCard } from "../../detail/template-card"
import {styled} from "@mui/material/styles";
import {tooltipClasses, TooltipProps} from "@mui/material/Tooltip";

const CustomWidthTooltip = styled(
	({ className, ...props }: TooltipProps) => (
		<Tooltip {...props} classes={{ popper: className }} />
	))({
	[`& .${tooltipClasses.tooltip}`]: {
		maxWidth: 400,
	},
})

interface TemplateColumnOneProps
{
	handlePagination: (value: number) => void
	onItemSelected: (template: Template) => void
	openAssignTemplate: (template: Template) => void
	openDeleteTemplate: (template: Template) => void
	setDefault: (template: Template) => void
	cloneWorkflowTemplate: (template: Template) => void
	createWorkflowFromTemplate: (template: Template) => void
	openCreateNewTemplate: () => void
	selectedTemplateId: string|null
	templates: PaginatedResponse<Template>
}
interface TemplateColumnOneState
{
	openPlaceholderInfo: boolean
}

export class TemplateColumnOne extends React.Component<TemplateColumnOneProps, TemplateColumnOneState>
{

	constructor(props: TemplateColumnOneProps) {
		super(props);
		this.state = {
			openPlaceholderInfo: false
		}
	}

	private handlePagination = (_: React.ChangeEvent<unknown>, value: number) => {
		this.props.handlePagination(value)
	}

	private openPlaceholderInfo = () => {
		this.setState(() => ({
			openPlaceholderInfo: true
		}))
	}

	private closePlaceholderInfo = () => {
		this.setState(() => ({
			openPlaceholderInfo: false
		}))
	}

	render()
	{
		const items = this.props.templates?.items ?? []
		const pagination: PaginationInfo|undefined = this.props.templates?.pagination

		return (
			<>
				<TabContext value="1">
					<Box sx={{ borderBottom: 0 }}>
						<SbTabList variant="fullWidth">
							<SbTab
								disableRipple
								disableTouchRipple
								label={t({ id: "workflow.template.template", message: "Template workflows", })}
								value="1" />
						</SbTabList>
					</Box>
					<TabPanel value="1" sx={{ px: 0, }}>
						<Stack direction="column">
							{items.length !== 0 &&
								<Box display="flex" justifyContent={"center"}>
									<Pagination
										showFirstButton
										showLastButton
										page={(pagination?.currentPage ?? 0) + 1}
										count={pagination?.totalPages ?? 1}
										onChange={this.handlePagination}/>
								</Box>
							}
							{items.length === 0 ?
								<Typography sx={{pt: 5, height: "47vh"}} display="flex" justifyContent={"center"}>Nessun template disponibile</Typography>
								 :
								<>
									<List  sx={{ width: "100%", height: "47vh", overflow: "auto"}}>
										{items.map((data: Template) => (
											<Box key={data.id}>
												<ListItemButton
													key={data.id}
													onClick={() => this.props.onItemSelected(data)}
													selected={this.props.selectedTemplateId === data.id}>
													<TemplateCard
														data={data}
														openDeleteDialog={() => this.props.openDeleteTemplate(data)}
														openAssignDialog={() => this.props.openAssignTemplate(data)}
														setDefault={() => this.props.setDefault(data)}
														cloneWorkflowTemplate={() => this.props.cloneWorkflowTemplate(data)}
														createWorkflowFromTemplate={() => this.props.createWorkflowFromTemplate(data)}
													/>
												</ListItemButton>
												<Divider />
											</Box>
										))}
									</List>
								</>
							}
							<Stack direction={"row"} alignItems={"center"} sx={{mt: 1, ml: 3}} spacing={2}>
								<Button
									startIcon={<Icon path={mdiPlusBox} size={1} />}
									variant="contained"
									sx={{
										color: "background.default",
										backgroundColor: "secondary.main",
										textTransform: "none",
										width: "fit-content"
									}}
									disableElevation
									onClick={this.props.openCreateNewTemplate}>
									<Trans id="workflow.add-new-template">
										Aggiungi nuovo template
									</Trans>
								</Button>
								<CustomWidthTooltip title={<Typography fontSize={"0.9rem"}>
													<Trans id="placeholder-info-dialog.body">
														Alla creazione di un template è possibile utilizzare dei placeholder, ossia delle parole chiave che verranno sostituite in fase di creazione di un workflow.
													</Trans>
												</Typography>}
										 arrow
										 placement={"right"}
								>
									<IconButton sx={{color: "secondary.main"}} onClick={this.openPlaceholderInfo}>
										<Icon path={mdiInformationOutline} size={1.2} />
									</IconButton>
								</CustomWidthTooltip>
							</Stack>
						</Stack>
					</TabPanel>
				</TabContext>
			</>
		)
	}
}
